// client/src/lib/call-providers/KioCallProvider.ts

import { CallProviderCallbacks, ICallProvider } from './ICallProvider';

// Note: bool return types from KW come through as numbers, so they require explicit conversion to boolean.
class KioCallProvider implements ICallProvider {
	callGroup(groupId: string): boolean {
		if (typeof KioCall === 'undefined') return false;
		return Boolean(KioCall.CallGroup(groupId));
	}

	isCallActive(): boolean {
		if (typeof KioCall === 'undefined') return false;
		return Boolean(KioCall.IsCallActive());
	}

	isGroupAvailable(groupId: string): boolean {
		if (typeof KioCall === 'undefined') return false;
		return Boolean(KioCall.IsGroupAvailable(groupId));
	}

	registerCallbacks(callbacks: CallProviderCallbacks): void {
		window.OnKioCallReady = callbacks.onReady;
		window.OnKioCallStarted = callbacks.onCallStarted;
		window.OnKioCallEnded = callbacks.onCallEnded;
		window.OnKioCallUpdateUserList = callbacks.onUserListUpdated;
	}

	unregisterCallbacks(): void {
		window.OnKioCallReady = undefined;
		window.OnKioCallStarted = undefined;
		window.OnKioCallEnded = undefined;
		window.OnKioCallUpdateUserList = undefined;
	}
}

const kioCallProvider = new KioCallProvider();
export default kioCallProvider;
